import { render, staticRenderFns } from "./SampleOrderComplete.vue?vue&type=template&id=6be08408&scoped=true&"
import script from "./SampleOrderComplete.vue?vue&type=script&lang=js&"
export * from "./SampleOrderComplete.vue?vue&type=script&lang=js&"
import style0 from "./SampleOrderComplete.vue?vue&type=style&index=0&id=6be08408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be08408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VDivider,VStepper,VStepperHeader,VStepperStep})
